/* global envision:false */
/**
 * Copyright (C) Sitevision AB 2002-2024, all rights reserved
 */
import { imgSlideshow } from '../util/slideShow';
import '../util/static/defaultlist.css';
import './tabPlugins';
import { hasSubPortlet } from '../util/findPortlets';

if (hasSubPortlet('sv-contentlist-portlet', '.sv-carousel')) {
  document.querySelectorAll('.sv-contentlist-portlet:has(.sv-carousel)').forEach((portlet) => {
    const selector = '#' + portlet.id;
    imgSlideshow(selector);
  });
}

if (hasSubPortlet('sv-contentlist-portlet', '.env-tabs')) {
  document.querySelectorAll('.sv-contentlist-portlet:has(.env-tabs)').forEach((portlet) => {
    const tabs = portlet.querySelector('.env-tabs');
    if (tabs) {
      envision.tabs(tabs);
    }
  });
}
